import React from 'react';

import { flagStyles } from '../settings';

const SvgGD = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1824px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGD;
